import { render } from "./ProviderSelectModal.vue?vue&type=template&id=b1f0ca5c&scoped=true"
import script from "./ProviderSelectModal.vue?vue&type=script&lang=js"
export * from "./ProviderSelectModal.vue?vue&type=script&lang=js"

import "./ProviderSelectModal.vue?vue&type=style&index=0&id=b1f0ca5c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-b1f0ca5c"

export default script